module.exports = __webpack_public_path__ + "media/images/iconPaginateLast-5350e7292ec77fc8f1b345ffc1d227e6.png";